import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { createSlug } from '../../util/urlHelpers';

import { Modal, ResponsiveImage, NamedLink, H4 } from '../../components';

import CollectionInterestForm from './CollectionInterestForm';
import ListPieceForSaleButton from './ListPieceForSaleButton';

import css from './CollectionPieceModal.module.css';

const largeVariants = image =>
  Object.keys(image?.attributes?.variants || {}).filter(
    k => k.startsWith('scaled-') || k.startsWith('listing-card')
  );

/**
 * Nextmine: detalje-visning af ét samlingsstykke.
 *
 * Ét stykke er ikke en vare, så det får ikke en købs-side - det åbnes roligt
 * ovenpå samlingen. Er man ikke ejeren, kan man sige at man er interesseret;
 * det bliver til en tråd i ejerens indbakke. Er man ejeren, er det herfra man
 * kan sætte stykket til salg.
 */
const CollectionPieceModal = props => {
  const {
    piece,
    isOpen,
    onClose,
    onManageDisableScrolling,
    collectorName,
    isOwnPiece,
    isAuthenticated,
  } = props;

  const title = piece?.attributes?.title || '';
  const description = piece?.attributes?.description || '';
  const images = piece?.images || [];

  return (
    <Modal
      id="CollectionPage.piece"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
      contentClassName={css.modalContent}
    >
      {piece ? (
        <div className={css.root}>
          <div className={css.gallery}>
            {images.map(image => (
              <div className={css.imageFrame} key={image.id.uuid}>
                <ResponsiveImage
                  rootClassName={css.image}
                  alt={title}
                  image={image}
                  variants={largeVariants(image)}
                  sizes="(max-width: 767px) 90vw, 520px"
                />
              </div>
            ))}
          </div>

          <div className={css.details}>
            <H4 as="h2" className={css.title}>
              {title}
            </H4>
            {description ? <p className={css.description}>{description}</p> : null}

            {isOwnPiece ? (
              <>
                <ListPieceForSaleButton className={css.sellSection} piece={piece} />
                <NamedLink
                  className={css.publicLink}
                  name="ListingPage"
                  params={{ id: piece.id.uuid, slug: createSlug(title) }}
                >
                  <FormattedMessage id="CollectionPage.viewPiecePage" />
                </NamedLink>
              </>
            ) : (
              <CollectionInterestForm
                className={css.interestSection}
                piece={piece}
                collectorName={collectorName}
                isAuthenticated={isAuthenticated}
              />
            )}
          </div>
        </div>
      ) : null}
    </Modal>
  );
};

export default CollectionPieceModal;
